import { termsOfUse } from "@serophin/shared";
import { CONTACT_US, NOTTLDR_LEGAL } from "./app";
import { TERMS_LAW } from "./termsLaw";
import { TERMS_LIABILITY } from "./termsLiability";
import { TERMS_AGREEMENT, TERMS_SERVICE } from "./termsService";

export const NOTTLDR_TERMS = termsOfUse(NOTTLDR_LEGAL, {
  title: "Terms of Use",
  contents: true,
  numbered: true,
  agreement: TERMS_AGREEMENT,
  sections: [...TERMS_SERVICE, ...TERMS_LIABILITY, ...TERMS_LAW],
  changes:
    "We may update these Terms occasionally. The date at the top shows the current version, and continued use of the Service after a change indicates acceptance of the updated Terms.",
  closing: [
    `If anything in these Terms is unclear, please ${CONTACT_US} before using the Service.`,
    "By using !tldr, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use.",
  ],
});
